import React, {useEffect, useState} from "react"
import {useNavigate} from "react-router-dom";
import {useSearchParams} from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import {
  ButtonTypeEnum, ButtonSizeEnum, ButtonColorEnum
} from "components/shared/enums/global-enums.tsx";

import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import AppButton from "components/shared/AppButton/AppButton"
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';
import variables from "utils/_variables.module.scss";

import {AppRoutes} from "utils/routes";

import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';

import useStore from "store/store";
import './DepartureDate.scss'

const today = dayjs();


export default function DepartureDate(){
  
  const {t} = useTranslation();
  const navigate = useNavigate();
  let [, setSearchParams] = useSearchParams();
  let storeActions = useStore((state)=> state.actions);
  const flightRecordAttempt = useStore((state)=> state.flightRecordAttempt);

  const [bookingCode, setBookingCode] = useState('');
  const [showCodeError, setShowCodeError] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  useEffect(()=>{
    if (!flightRecordAttempt.flight || !flightRecordAttempt.flight){
      navigate("/");
    }
  }, [flightRecordAttempt, navigate]);

  function handleBack(argument) {
    storeActions.setFlightRecordAttempt({ ...flightRecordAttempt, flightDate: null });
    setSearchParams(params => {
      params.delete("departureDate");
      params.set("selectFlight", 1);
      return params;
    });
  }

  function handleGo(argument) {
    storeActions.saveFlightRecord(flightRecordAttempt, ()=>{
      let lockedFR = storeActions.checkLockedFlightRecords();
      if ( lockedFR) handleOpen();
      else handleRedirect();
    });
  }



  function handleRedirect(){
    if (storeActions.checkLockedFlightRecords() && !bookingCode) {
      setShowCodeError(true);
      return;
    }

    const updatedFRs = useStore.getState().flightRecords;

    let pnr = updatedFRs[0]?.pnr;
    
    let values = {airline: flightRecordAttempt.airline.name, first_name: flightRecordAttempt.firstName, last_name: flightRecordAttempt.lastName, pnr: pnr, booking_code: bookingCode};
    let prmStr = new URLSearchParams(values).toString();
    navigate(AppRoutes.flightsPath+"?"+prmStr);
  }


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>

    <Box className="dd-container">

      <Typography variant="span" className="h5 font-1-heavy primary1-color">
        {t("Select your departure date:")}
      </Typography>

      <div className="v-space-3"></div>
      
      <StaticDatePicker      minDate={today} onChange={(newValue) => storeActions.setFlightRecordAttempt({ ...flightRecordAttempt, flightDate: newValue })} />

      
      <Grid container spacing={4}>
        <Grid item xs={6} sm={6} md={6} lg={6} >
          <AppButton 
            sx={{width: '100%', color: variables['primary4-color']}}
            buttonLabel={ t("Back") }
            buttonColor={ButtonColorEnum.PRIMARY2_BG}
            buttonType={ButtonTypeEnum.PRIMARY}
            buttonSize={ButtonSizeEnum.MEDIUM}
            onClickFunc={handleBack}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} >
          {
            flightRecordAttempt?.flightDate &&
            <AppButton 
              sx={{width: '100%'}}
              buttonLabel={ t("Go!") }
              buttonType={ButtonTypeEnum.PRIMARY}
              buttonSize={ButtonSizeEnum.MEDIUM}
              onClickFunc={handleGo}
            />
          }
        </Grid>
      </Grid>

      <div className="v-space-7"></div>


      <Modal open={open}  onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className="lock-popup">
          <div className="d-f para2 primary3-color font-1-heavy ai-c">
            {t("Booking Code is required for this flight")} <ReportProblemIcon sx={{fontSize: 16}} />
          </div>
          <div className="v-space-2" ></div>
          <div className="d-f para2 black-color font-1-book ai-c">
            {t("Services have already been booked for this trip. Please provide the booking code to access the flight information")}
          </div>
          <div className="v-space-2" ></div>
          <div >
            <input  className="field w-100 para2 font-1-book" onChange={e => setBookingCode(e.target.value)} placeholder={t('Booking Code')} />
            <div className="v-space-1"></div>
            {showCodeError && <div className="error-color">{t("Required")}</div>}
            <div className="v-space-1"></div>
          </div>
          <div className="v-space-2" ></div>
          <div className="d-f jc-r">
            <AppButton 
              buttonLabel={ t("Access Flight Now") }
              buttonType={ButtonTypeEnum.PRIMARY}
              buttonSize={ButtonSizeEnum.SMALL}
              onClickFunc={handleRedirect}
            />
          </div>
        </Box>
      </Modal>
   
    </Box>

    </LocalizationProvider>
    )
}